/** Derivative notation: f′(x), f″(x), f‴(x), f⁽⁴⁾(x), and the LaTeX equivalents. */

const SUPERSCRIPT_DIGITS = "⁰¹²³⁴⁵⁶⁷⁸⁹";

function superscriptNumber(n: number): string {
  return [...String(n)].map((d) => SUPERSCRIPT_DIGITS[Number(d)]).join("");
}

/** "f′(x)" for order 1, "f⁽⁴⁾(x)" for order 4. */
export function primeSymbol(order: number, name = "f", variable = "x"): string {
  const marks = ["", "′", "″", "‴"];
  const mark =
    order < marks.length ? marks[order] : `⁽${superscriptNumber(order)}⁾`;
  return `${name}${mark}(${variable})`;
}

export function primeLatex(order: number, name = "f", variable = "x"): string {
  if (order <= 3) {
    return `${name}${"'".repeat(order)}(${variable})`;
  }
  return `${name}^{(${order})}(${variable})`;
}

/** "d/dx" for order 1, "d²/dx²" for order 2. */
export function leibniz(order: number, variable = "x"): string {
  if (order === 1) {
    return `d/d${variable}`;
  }
  const sup = superscriptNumber(order);
  return `d${sup}/d${variable}${sup}`;
}
